import { api } from '../../../api';

export const userActiveAPI = userData => {
  return api.put(`/v1/accounts/confirmations/confirm_account`, userData);
};
